
import { australiaData } from './australia';
import { newZealand } from './newZealand';
import { papuaNewGuinea } from './papuaNewGuinea';
import { fiji } from './fiji';
import { oceaniaExpansion3 } from './oceaniaExpansion3';
import { oceaniaExpansion4 } from './oceaniaExpansion4';

export const oceaniaCountries = [
  // Usar solo las versiones expandidas más recientes
  newZealand,
  papuaNewGuinea,
  fiji,
  ...oceaniaExpansion3, // Incluye Australia expandida Fase 9 (150+ ciudades)
  ...oceaniaExpansion4  // Incluye Samoa, Tonga y Vanuatu - Fase 12
];
